export default __webpack_public_path__ + "static/mapboxUserName-008ac0a91177bd989bbc20fcb4a25ed2.png";